module.exports = __webpack_public_path__ + "img/powered.c72a45ac.svg";